<router-outlet (activate)="onActivate()"></router-outlet>